import React, {
  HTMLAttributes,
} from 'react';
import cx from 'classnames';

export const Panel = ({children}: {children: React.ReactNode}) => {
  return (
    <div
      className={
        'flex flex-col bg-white border border-[#e3e4e6] w-[440px] min-h-[440px] px-4 pb-4 rounded'
      }
    >
      {children}
    </div>
  );
};

export const Tags: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div
      {...rest}
      className={cx(
        'relative group bg-white py-1 px-7 m-1 min-h-[25px] !w-max',
        'inline-flex items-center justify-center',
        'bg-white border border-[#e2e4e6] rounded-[100px]',
        className,
      )}
    >
      {children}
    </div>
  );
};